/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useEffect } from 'react'
import ic_portal_api from "../../assets/images/pictures/icon/ic_portal-api.svg"
import signature_collection from "../../assets/images/pictures/signature-collection-header.png"
import ic_setting_circle from "../../assets/images/pictures/icon/ic_settings_circle.svg"
import ic_puzzle_circle from "../../assets/images/pictures/icon/ic_puzzle_circle.svg"
import ic_thunder_circle from "../../assets/images/pictures/icon/ic_thunder_big_circle.svg"
import ic_storage from "../../assets/images/pictures/icon/ic_storage.svg"
import ic_paint from "../../assets/images/pictures/icon/ic_paint.svg"
import ic_books from "../../assets/images/pictures/icon/ic_books.svg"
import ic_key_circle from "../../assets/images/pictures/icon/ic_key_big_circle.svg"
import ic_doc_cirlce from "../../assets/images/pictures/icon/ic_doc_circle.svg"
import ic_doc_code_circle from "../../assets/images/pictures/icon/ic_doc-code_circle.svg"
import gopaperless_service from "../../assets/images/pictures/solutions-footer.png"
import { motion } from "framer-motion"
import { useTranslation } from 'react-i18next'
import routeVariants from '../../assets/animates/routeVariants'
import { useState } from 'react';
import { useRef } from 'react';
import Modal from './../global/Modal';
import FPT_logo from "../../assets/images/logos/CA/FPT-CA-1.png"
import Fast_logo from "../../assets/images/logos/CA/FastCA-1.png"
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';



const SignatureCollectionContent = (props) => {
    const [modalPortalOpen, setModalPortalOpen] = useState(false);

    const [modalApiOpen, setModalApiOpen] = useState(false);

    const [modalOpen, setModalOpen] = useState(false);

    useEffect(() => {
        if (modalOpen === true || modalPortalOpen === true || modalApiOpen === true) {
            document.body.style.overflow = "hidden";

        } else {
            document.body.style.overflow = "auto";
        }
    }, [modalOpen, modalPortalOpen, modalApiOpen])

    const modalRef = useRef(null);

    const handleOverlayClick = (event) => {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
            setModalOpen(false)
            setModalApiOpen(false)
            setModalPortalOpen(false)
        }
    };

    document.onkeydown = function (evt) {
        if (evt.code === 'Escape') {
            setModalOpen(false)
            setModalApiOpen(false)
            setModalPortalOpen(false)
        }
    };

    const { t } = useTranslation()

    useEffect(() => {

        if (props.following === true) {
            document.getElementById("signature-collection").classList.add("active", "in")
        }
        else {
            document.getElementById("signature-collection").classList.remove("active", "in")
        }
    }, [props.following])



    return (
        <>
            <motion.div
                variants={routeVariants}
                initial="initial"
                animate="final"
                className="tab-pane fade" id="signature-collection" >
                <div className="bg-color p-md-0 " >
                    <div className="container pt-100 pb-100 px-md-0">
                        <div className="row api-solutions">
                            <div className="col-sm-6 ">
                                <img width="64" height="64" src={ic_portal_api} className="attachment-full size-full" alt="" decoding="async" loading="lazy" data-no-retina="" />
                                <h2 className="heading font-weight-bold">{t('signature-collection-page.signature-collection-page-content.content-1.heading')}</h2>
                                <div className="subheading">
                                    <p>{t('signature-collection-page.signature-collection-page-content.content-1.description')}</p>
                                </div>
                                <ul className="list-inline">
                                    <li>
                                        <img className="client-s-none-width img-bw" src={FPT_logo} alt="" />
                                    </li>
                                    <li>
                                        <img className="client-s-none-width img-bw" src={Fast_logo} alt="" />
                                    </li>
                                    
                                </ul>

                            </div>
                            <div className="col-sm-6 ">
                                <img src={signature_collection} className="img-responsive" alt="" decoding="async" loading="lazy" />
                            </div>
                        </div>
                    </div>

                </div>




                <div className="bg-color" style={{ background: "#fff" }} >

                    <div className="container api-solutions m-50">
                        <div className="row">
                            <div className="col-sm-12 px-md-0">
                                <div className="rectangle"></div>
                                <h2 className='font-weight-bold'>{t('signature-collection-page.signature-collection-page-content.content-2.big-heading')}</h2>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-6  pl-md-0">
                                <img width="40" height="40" src={ic_setting_circle} className="attachment-full size-full" alt="" decoding="async" loading="lazy" data-no-retina="" />
                                <h3>{t('signature-collection-page.signature-collection-page-content.content-2.small-heading-1')}</h3>
                                <p>{t('signature-collection-page.signature-collection-page-content.content-2.small-description-1')}</p>
                            </div>
                            <div className="col-sm-6 pr-md-0">
                                <img width="40" height="40" src={ic_puzzle_circle} className="attachment-full size-full" alt="" decoding="async" loading="lazy" data-no-retina="" />
                                <h3>{t('signature-collection-page.signature-collection-page-content.content-2.small-heading-2')}</h3>
                                <p>{t('signature-collection-page.signature-collection-page-content.content-2.small-description-2')}</p>
                            </div>
                        </div>
                    </div>

                </div>




                <div className="bg-primary pt-50 pb-50" >
                    <div className="container api-solutions api-solutions--features">
                        <div className="row">
                            <div className="text-center col-xs-12">
                                <img width="64" height="64" src={ic_thunder_circle} className="attachment-full size-full" alt="" decoding="async" loading="lazy" data-no-retina="" />
                                <h2 className='font-weight-bold text-white'>{t('signature-collection-page.signature-collection-page-content.content-3.big-heading')}</h2>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-4 pl-md-0">
                                <div className="media-list">
                                    <div className="media text-center signature-collection-card">
                                        <div className="media-body ">
                                            <img width="24" height="24" src={ic_storage} className="attachment-full size-full" alt="" decoding="async" loading="lazy" data-no-retina="" />
                                            <h4>{t('signature-collection-page.signature-collection-page-content.content-3.small-heading-1')}</h4>
                                            <p>{t('signature-collection-page.signature-collection-page-content.content-3.small-description-1')}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-4">
                                <div className="media-list">
                                    <div className="media text-center signature-collection-card">
                                        <div className="media-body">
                                            <img width="24" height="24" src={ic_paint} className="attachment-full size-full" alt="" decoding="async" loading="lazy" data-no-retina="" />
                                            <h4>{t('signature-collection-page.signature-collection-page-content.content-3.small-heading-2')}</h4>
                                            <p>{t('signature-collection-page.signature-collection-page-content.content-3.small-description-2')}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-4 pr-md-0">
                                <div className="media-list">
                                    <div className="media text-center signature-collection-card">
                                        <div className="media-body">
                                            <img width="24" height="24" src={ic_books} className="attachment-full size-full" alt="" decoding="async" loading="lazy" data-no-retina="" />
                                            <h4>{t('signature-collection-page.signature-collection-page-content.content-3.small-heading-3')}</h4>
                                            <p>{t('signature-collection-page.signature-collection-page-content.content-3.small-description-3')}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>




                <div className="container mt-100">
                    <div className="row api-solutions">
                        <div className="col-sm-6 col-sm-offset-3 text-center">
                            <img width="64" height="64" src={ic_key_circle} className="attachment-full size-full" alt="" decoding="async" loading="lazy" data-no-retina="" />
                            <h2 className="heading font-weight-bold">{t('signature-collection-page.signature-collection-page-content.content-4.big-heading')}</h2>
                            <p className="subheading mb-50">{t('signature-collection-page.signature-collection-page-content.content-4.big-description')}</p>
                        </div>
                    </div>
                    <div className="row api-solutions flex">
                        <div className="col-sm-6 flex pl-md-0">
                            <div className="card">
                                <div className="card__body">
                                    <img width="40" height="40" src={ic_doc_cirlce} className="attachment-full size-full" alt="" decoding="async" loading="lazy" data-no-retina="" />
                                    <h3>{t('signature-collection-page.signature-collection-page-content.content-4.small-heading-1')}</h3>
                                    <p>{t('signature-collection-page.signature-collection-page-content.content-4.small-description-1')}</p>
                                    <div className="btns-inline">
                                        <p><a href="javascript:;">{t('signature-collection-page.signature-collection-page-content.content-4.small-link-1-1')}</a></p>
                                        <p><a href="javascript:;">{t('signature-collection-page.signature-collection-page-content.content-4.small-link-1-2')}</a></p>
                                    </div>
                                    <a href="javascript:;"
                                        onClick={() => setModalPortalOpen(true)}
                                        className="btn-secondary">
                                        {t('signature-collection-page.signature-collection-page-content.content-4.button-contact-us')}
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 flex pr-md-0">
                            <div className="card">
                                <div className="card__body">
                                    <img width="40" height="40" src={ic_doc_code_circle} className="attachment-full size-full" alt="" decoding="async" loading="lazy" data-no-retina="" />
                                    <h3>{t('signature-collection-page.signature-collection-page-content.content-4.small-heading-2')}</h3>
                                    <p>{t('signature-collection-page.signature-collection-page-content.content-4.small-description-2')}</p>
                                    <div className="btns-inline">
                                        <p><a href="javascript:;">{t('signature-collection-page.signature-collection-page-content.content-4.small-link-2-1')}</a></p>
                                        <p><a href="javascript:;">{t('signature-collection-page.signature-collection-page-content.content-4.small-link-2-2')}</a></p>
                                    </div>
                                    <a href="javascript:;"
                                        onClick={() => setModalApiOpen(true)}
                                        className="btn-secondary">{t('signature-collection-page.signature-collection-page-content.content-4.button-contact-us')}</a>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div className="api-solutions bg-color--img-overlap mt-100 bg-color" >
                    <div className="container identification-footer">
                        <div className="row">
                            <div className="col-sm-6 pl-md-0">
                                <h2 className="heading font-weight-bold">{t('signature-collection-page.signature-collection-page-content.content-5.heading')}</h2>
                                <div className="subheading">
                                    <p>{t('signature-collection-page.signature-collection-page-content.content-5.description')}</p>
                                </div>
                                <a href="javascript:;"
                                    onClick={() => setModalOpen(true)}
                                    className="btn-secondary">{t('signature-collection-page.signature-collection-page-content.content-5.button-contact-us')}</a>


                            </div>
                            <div className="col-sm-6 pl-md-0">
                                <img src={gopaperless_service} width="400px" className="bg-color--img-overlap__img img-responsive" alt="gopaperless_service" decoding="async" loading="lazy" />
                            </div>
                        </div>
                    </div>
                </div>
            </motion.div>
            {modalOpen && <Modal setOpenModal={setModalOpen} handleOverlayClick={handleOverlayClick} modalRef={modalRef} heading={t('modal.heading-found-solution-fit')} description={t('modal.description-get-started')} type="Solutions - Signature Collection - Signature collection in your e-service" />}
            {modalPortalOpen && <Modal setOpenModal={setModalPortalOpen} handleOverlayClick={handleOverlayClick} modalRef={modalRef} heading={t('modal.heading-portal-api')} description={t('modal.description-fillout-reach')} type="Solutions - Signature Collection - Portal API / Universal API" />}
            {modalApiOpen && <Modal setOpenModal={setModalApiOpen} handleOverlayClick={handleOverlayClick} modalRef={modalRef} heading={t('modal.heading-portal-api-connector')} description={t('modal.description-fillout-reach')} type="Solutions - Signature Collection - Portal API connector / Universal API connector"/>}
            <ToastContainer/>
        </>
    )
}

export default SignatureCollectionContent